var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMavenJava(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 6.84118,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5906 6.64131C11.22 7.88003 11.0264 9.16494 11.0156 10.4579L13.0669 11.4512C13.0283 10.2318 13.0764 9.01112 13.2107 7.7985C13.2179 7.71512 13.2265 7.66625 13.2265 7.66625C13.2265 7.71081 13.2136 7.75394 13.2107 7.7985C13.1146 8.99779 13.1132 10.2028 13.2064 11.4023C14.2689 10.4977 15.2832 9.53806 16.2452 8.52731C16.0431 7.98919 15.7367 7.49623 15.3438 7.07665C14.9509 6.65707 14.479 6.31911 13.9553 6.08212C13.9553 6.08212 12.1383 5.349 11.5906 6.64131Z",
    fill: "url(#paint0_linear_5429_43267)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7024 22.3984C18.6061 22.5034 18.5069 22.6026 18.4062 22.7018C18.458 22.6543 18.5112 22.5982 18.5601 22.5465C18.6104 22.5 18.6579 22.4505 18.7024 22.3984Z",
    fill: "#BE202E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M18.7024 22.3984C18.6061 22.5034 18.5069 22.6026 18.4062 22.7018C18.458 22.6543 18.5112 22.5982 18.5601 22.5465C18.6104 22.5 18.6579 22.4505 18.7024 22.3984Z",
    fill: "#BE202E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9507 20.7621C17.9679 20.7491 17.9808 20.7319 17.9967 20.7189C18.0613 20.6543 18.126 20.5896 18.1807 20.5234C18.1088 20.6025 18.0283 20.6787 17.9507 20.7621Z",
    fill: "#BE202E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M17.9507 20.7621C17.9679 20.7491 17.9808 20.7319 17.9967 20.7189C18.0613 20.6543 18.126 20.5896 18.1807 20.5234C18.1088 20.6025 18.0283 20.6787 17.9507 20.7621Z",
    fill: "#BE202E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6087 17.5081C13.5129 16.8257 13.4266 16.1549 13.35 15.4956C13.2709 14.8099 13.2062 14.1371 13.1616 13.4716C13.1616 13.4313 13.1545 13.3911 13.1616 13.3551C13.1085 12.7054 13.0768 12.0715 13.0625 11.4505L11.014 10.4629C11.014 10.5865 10.9996 10.7145 10.9953 10.8496C10.9752 11.3398 10.9594 11.8558 10.9551 12.4093C10.9551 13.0274 10.9551 13.6714 10.9666 14.3456C10.981 14.9666 11.0068 15.6135 11.0399 16.2718C11.073 16.8353 11.1103 17.4046 11.1563 17.9853C11.1563 18.0098 11.1563 18.0256 11.1563 18.0515L13.8962 19.4386C13.8056 18.7903 13.705 18.1463 13.6087 17.5081Z",
    fill: "url(#paint1_linear_5429_43267)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6623 33.7075C17.8061 34.2193 17.9671 34.7468 18.1338 35.2816C18.1338 35.2816 18.1338 35.2974 18.1338 35.3032C18.1568 35.3808 18.1755 35.4541 18.2042 35.5288C18.3135 35.8897 18.4184 36.2102 18.6456 36.9433C19.1956 36.9097 19.7431 37.0408 20.2182 37.32C19.8455 36.8629 19.308 36.5706 18.7218 36.5063C19.5109 36.1037 20.1736 35.4912 20.637 34.7361C21.1004 33.9811 21.3464 33.1128 21.3481 32.2269C21.3308 32.0745 21.3107 31.9164 21.2805 31.7583C21.2639 32.1081 21.1527 32.4468 20.9588 32.7384C20.7649 33.0301 20.4955 33.2636 20.1794 33.4143C20.8437 32.4067 21.1524 31.2061 21.0563 30.0031C21.0347 29.7257 20.9988 29.4281 20.9484 29.1133C20.8686 29.8739 20.5917 30.6005 20.1449 31.2212C19.6982 31.8419 19.0971 32.3353 18.4012 32.6524L17.5703 33.4172C17.6005 33.5135 17.6264 33.6083 17.6623 33.7075Z",
    fill: "url(#paint2_linear_5429_43267)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5889 31.3689C16.415 30.7192 16.241 30.0594 16.0642 29.3938C15.8975 28.7555 15.7379 28.1115 15.5783 27.4589C15.4188 26.8063 15.265 26.1494 15.1126 25.4924C14.9602 24.8355 14.8107 24.1498 14.6698 23.4799C14.529 22.81 14.3967 22.1416 14.2645 21.4775C14.217 21.236 14.1739 21.0002 14.1308 20.7587C14.0546 20.3476 13.987 19.9336 13.9123 19.5182C13.9123 19.4966 13.9051 19.4722 13.8979 19.4506L11.1738 18.0605C11.1801 18.1039 11.1835 18.1476 11.1839 18.1914C11.2385 18.808 11.2917 19.4348 11.365 20.0601C11.4383 20.6854 11.5174 21.3395 11.6123 21.9878C11.6928 22.534 11.779 23.076 11.8696 23.6237C11.8883 23.7315 11.9098 23.845 11.9285 23.9514C12.0536 24.6285 12.1887 25.2825 12.3339 25.8935C12.4963 26.5864 12.6717 27.2361 12.8471 27.8427C12.965 28.2395 13.0814 28.6219 13.2007 28.9841C13.3042 29.2889 13.4163 29.595 13.5241 29.8969C13.7843 30.6056 14.0733 31.2927 14.3866 31.964L17.1395 33.3584C16.9957 32.8524 16.852 32.3378 16.7082 31.816C16.668 31.665 16.6306 31.5199 16.5889 31.3689Z",
    fill: "url(#paint3_linear_5429_43267)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4235 32.0491C14.7967 32.8543 15.2197 33.6354 15.69 34.388C15.7058 34.411 15.7216 34.4426 15.7374 34.4656C15.0546 34.2782 14.3422 34.223 13.6387 34.3031C14.9168 34.6585 16.0817 35.3373 17.0211 36.274C16.5655 36.6734 16.0152 36.9496 15.4226 37.0761C16.0109 37.173 16.6142 37.1196 17.1764 36.9208C16.6361 37.5028 16.267 38.2226 16.1097 39.0009C16.4973 38.2346 17.0991 37.5974 17.8419 37.1666C18.6685 39.9065 19.6632 42.8764 20.7658 45.9929C20.8502 45.8842 20.9062 45.7562 20.9288 45.6204C20.9514 45.4846 20.9398 45.3454 20.8952 45.2152C20.6925 44.656 19.38 40.9487 17.8836 35.9175C17.8405 35.7737 17.8031 35.63 17.7557 35.4862C17.7427 35.4445 17.7327 35.4086 17.7197 35.3655C17.5664 34.8384 17.4102 34.296 17.2511 33.7382C17.2166 33.6088 17.1792 33.4881 17.1447 33.3573L14.3919 31.9629C14.3999 31.9925 14.4104 32.0214 14.4235 32.0491Z",
    fill: "url(#paint4_linear_5429_43267)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2203 19.4961C14.2361 19.5881 14.2533 19.67 14.2691 19.7635C14.3223 20.0366 14.3698 20.3126 14.4258 20.59C14.4833 20.8933 14.5466 21.2024 14.607 21.5201C14.6371 21.6796 14.6673 21.8392 14.7018 22.0031C14.801 22.4918 14.9088 22.9921 15.0195 23.5081C15.1633 24.1421 15.307 24.7933 15.4666 25.4718C15.6103 26.1129 15.78 26.7813 15.9496 27.4613C16.1149 28.1096 16.2816 28.7737 16.4656 29.4608C16.6266 30.0689 16.8006 30.6942 16.976 31.3296C16.976 31.3598 16.9961 31.3928 17.0018 31.423C17.1786 32.0541 17.3641 32.7053 17.5567 33.368C17.5579 33.3826 17.5623 33.3969 17.5696 33.4096L18.4005 32.6449C18.379 32.6449 18.3631 32.6636 18.3358 32.6751C19.4648 31.4331 20.1731 29.8667 20.3598 28.1987C20.4483 27.3682 20.4397 26.5302 20.334 25.7018C20.2461 24.982 20.1126 24.2685 19.9343 23.5656C19.7705 22.9073 19.5692 22.2086 19.3234 21.4726C19.1541 21.8049 18.9409 22.1129 18.6895 22.3883L18.5457 22.5465C18.4983 22.5996 18.4451 22.6456 18.3919 22.7017C19.0529 21.6241 19.2674 20.3312 18.9899 19.0979C18.8043 19.6186 18.5257 20.1013 18.1676 20.5225C18.113 20.5886 18.0483 20.6533 17.9836 20.718C17.9664 20.7309 17.9535 20.7481 17.9319 20.7654C18.1587 20.3996 18.3379 20.0064 18.4652 19.5953C18.4905 19.5151 18.5112 19.4335 18.527 19.3509C18.5558 19.2258 18.5759 19.0993 18.5946 18.9728C18.6018 18.8895 18.6147 18.8118 18.6219 18.727C18.6385 18.5295 18.6385 18.3309 18.6219 18.1333C18.6219 18.0672 18.6219 18.0083 18.6061 17.9465C18.5903 17.8545 18.5788 17.7682 18.5615 17.6848C18.4954 17.301 18.4178 16.9661 18.3473 16.6786C18.31 16.5348 18.2755 16.4026 18.2381 16.2833C18.2208 16.2358 18.2122 16.1898 18.195 16.1395C18.1504 16.0087 18.1145 15.888 18.0742 15.7873C18.0302 15.6687 17.9798 15.5526 17.9233 15.4395C17.9096 15.4967 17.8893 15.5522 17.8629 15.6048C17.6216 16.0972 17.3065 16.55 16.9285 16.9474L17.6947 16.2473L16.9242 16.9431C16.9208 16.945 16.9178 16.9477 16.9156 16.9509C16.9133 16.9542 16.9119 16.9579 16.9113 16.9618C16.8717 17.0014 16.8342 17.0432 16.7991 17.0868C16.7991 17.0768 16.8121 17.0681 16.8135 17.0595L14.1973 19.453C14.2188 19.4716 14.2217 19.486 14.2203 19.4961Z",
    fill: "url(#paint5_linear_5429_43267)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.207 11.4022C13.2387 11.9772 13.289 12.6212 13.3508 13.3342C13.3521 13.3718 13.3564 13.4093 13.3637 13.4463C13.4227 14.0687 13.4988 14.74 13.5966 15.4717C13.68 16.1028 13.772 16.7655 13.8841 17.4842C13.9775 18.1067 14.0925 18.7578 14.2104 19.4493L16.8267 17.053C17.2716 16.3446 17.4999 15.5217 17.4836 14.6854C17.4836 14.4798 17.4678 14.2642 17.452 14.0428C17.4108 13.3533 17.335 12.6663 17.2248 11.9843C17.1277 11.3612 16.9976 10.7437 16.8353 10.1343C16.7509 9.81655 16.6507 9.50326 16.5348 9.19559C16.4414 8.96128 16.3437 8.74709 16.2473 8.54297C15.2826 9.54654 14.2679 10.5008 13.207 11.4022Z",
    fill: "url(#paint6_linear_5429_43267)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.564 22.5508C18.5165 22.604 18.4633 22.65 18.4102 22.706C18.4586 22.6515 18.5099 22.5997 18.564 22.5508Z",
    fill: "#BE202E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M18.564 22.5508C18.5165 22.604 18.4633 22.65 18.4102 22.706C18.4586 22.6515 18.5099 22.5997 18.564 22.5508Z",
    fill: "#BE202E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.564 22.5508C18.5165 22.604 18.4633 22.65 18.4102 22.706C18.4586 22.6515 18.5099 22.5997 18.564 22.5508Z",
    fill: "url(#paint7_linear_5429_43267)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9492 20.7662C17.9665 20.7532 17.9794 20.736 18.001 20.7188C17.9837 20.7317 17.9708 20.7489 17.9492 20.7662Z",
    fill: "#BE202E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M17.9492 20.7662C17.9665 20.7532 17.9794 20.736 18.001 20.7188C17.9837 20.7317 17.9708 20.7489 17.9492 20.7662Z",
    fill: "#BE202E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9492 20.7662C17.9665 20.7532 17.9794 20.736 18.001 20.7188C17.9837 20.7317 17.9708 20.7489 17.9492 20.7662Z",
    fill: "url(#paint8_linear_5429_43267)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4009 7.15552C37.1204 7.85982 35.9458 8.74158 34.9121 9.77464L35.7746 12.204C36.7127 11.1922 37.7215 10.2483 38.7934 9.37933C38.8667 9.31895 38.9112 9.28445 38.9112 9.28445C38.8739 9.31895 38.8307 9.34483 38.7934 9.37933C37.7605 10.2669 36.7992 11.2344 35.9184 12.273C37.491 12.39 39.0686 12.4245 40.6449 12.3765C40.9108 11.7821 41.0568 11.1409 41.0743 10.4899C41.0918 9.83891 40.9805 9.19085 40.7469 8.58295C40.7469 8.58295 39.8672 6.55033 38.4009 7.15552Z",
    fill: "url(#paint9_linear_5429_43267)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6071 25.4902C31.4461 25.4989 31.2865 25.4989 31.127 25.4989C31.206 25.4989 31.2937 25.4989 31.3742 25.4989C31.4519 25.5006 31.5297 25.4977 31.6071 25.4902Z",
    fill: "#BE202E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M31.6071 25.4902C31.4461 25.4989 31.2865 25.4989 31.127 25.4989C31.206 25.4989 31.2937 25.4989 31.3742 25.4989C31.4519 25.5006 31.5297 25.4977 31.6071 25.4902Z",
    fill: "#BE202E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3027 23.576C32.3257 23.576 32.3502 23.576 32.3746 23.576C32.4781 23.576 32.5816 23.576 32.6794 23.5645C32.5586 23.5645 32.4321 23.5645 32.3042 23.5731L32.3027 23.576Z",
    fill: "#BE202E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M32.3027 23.576C32.3257 23.576 32.3502 23.576 32.3746 23.576C32.4781 23.576 32.5816 23.576 32.6794 23.5645C32.5586 23.5645 32.4321 23.5645 32.3042 23.5731L32.3027 23.576Z",
    fill: "#BE202E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3928 17.5052C31.8586 16.8804 32.3224 16.2709 32.7843 15.6767C33.2644 15.0615 33.7503 14.4721 34.2405 13.8985C34.2693 13.8626 34.2994 13.8281 34.3268 13.7994C34.8069 13.2402 35.2841 12.7054 35.7643 12.1937L34.9018 9.77148C34.7997 9.8678 34.6904 9.96411 34.5798 10.0662C34.1729 10.4442 33.7474 10.8525 33.309 11.2895C32.8145 11.7825 32.3028 12.3058 31.7795 12.8578C31.2979 13.3695 30.8049 13.91 30.3089 14.4664C29.8878 14.9465 29.4651 15.4338 29.0411 15.9384L28.9922 15.9944L30.0948 19.2877C30.5332 18.694 30.963 18.0932 31.3928 17.5052Z",
    fill: "url(#paint10_linear_5429_43267)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7788 33.7635C21.4913 34.2953 21.2038 34.8416 20.9091 35.4051C20.9091 35.4123 20.8991 35.4195 20.8976 35.4266C20.8545 35.5086 20.8114 35.5819 20.7754 35.6638C20.5771 36.0405 20.4074 36.3826 20.0078 37.1531C20.4775 37.5628 20.8143 38.1034 20.9752 38.7056C21.0382 38.0419 20.8379 37.3801 20.4175 36.8627C22.6571 37.294 24.6912 37.0065 25.9317 35.5043C26.0396 35.3691 26.1474 35.2254 26.2494 35.073C25.958 35.3412 25.5992 35.5253 25.2115 35.6058C24.8237 35.6863 24.4213 35.6601 24.0472 35.5301C25.3829 35.2454 26.5851 34.5224 27.4627 33.476C27.6654 33.2345 27.8709 32.97 28.0822 32.6738C27.4137 33.2229 26.6133 33.5878 25.7604 33.7326C24.9074 33.8773 24.0315 33.7968 23.2192 33.499L21.9427 33.4544C21.8881 33.5636 21.832 33.66 21.7788 33.7635Z",
    fill: "url(#paint11_linear_5429_43267)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7773 31.0305C23.1539 30.3678 23.5377 29.6994 23.9272 29.018C24.301 28.3711 24.6819 27.7242 25.0772 27.0745C25.4726 26.4247 25.8664 25.7721 26.2646 25.1209C26.6628 24.4698 27.0883 23.7999 27.5109 23.1444C27.9336 22.4889 28.3548 21.8506 28.7745 21.2095C28.9283 20.9766 29.0807 20.7524 29.2417 20.5209C29.5062 20.1299 29.7793 19.7389 30.051 19.3494C30.0625 19.3278 30.0812 19.3063 30.0927 19.2833L29.0045 16C28.975 16.04 28.9428 16.0779 28.9082 16.1136C28.4626 16.6541 28.0083 17.2003 27.5656 17.7653C27.1228 18.3302 26.6714 18.9153 26.233 19.5147C25.8636 20.0178 25.5028 20.5209 25.1405 21.0356C25.0701 21.1362 24.9967 21.2454 24.9277 21.3475C24.4965 21.9929 24.0782 22.6254 23.7102 23.2335C23.2904 23.9206 22.9138 24.5833 22.576 25.2101C22.3561 25.6241 22.1448 26.0237 21.9536 26.4104C21.794 26.7381 21.6416 27.0731 21.4893 27.4023C21.1356 28.1785 20.8223 28.9619 20.5391 29.7497L21.6474 33.0559C21.9349 32.5313 22.231 32.0094 22.5257 31.4747C22.6047 31.3324 22.6939 31.1858 22.7773 31.0305Z",
    fill: "url(#paint12_linear_5429_43267)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4943 29.8604C20.1552 30.8052 19.8753 31.7702 19.6562 32.7498C19.6562 32.7814 19.6375 32.8188 19.6332 32.8504C19.2323 32.1569 18.7024 31.5465 18.0721 31.0521C18.8186 32.3536 19.2172 33.8254 19.2293 35.3258C18.5448 35.2852 17.8821 35.0699 17.3045 34.7005C17.701 35.2463 18.2291 35.6829 18.8397 35.9698C17.9426 36.0093 17.0737 36.2953 16.3284 36.7963C17.2494 36.4877 18.2402 36.4533 19.1804 36.6971C17.6624 39.5578 16.1099 42.739 14.5215 46.1243C14.6752 46.1034 14.8214 46.0446 14.9468 45.9533C15.0723 45.862 15.1731 45.7409 15.2402 45.601C15.5277 44.9886 17.4109 40.9636 20.2039 35.7225C20.2815 35.5788 20.3664 35.4278 20.4454 35.2711C20.4684 35.2266 20.4885 35.1892 20.5115 35.1461C20.8067 34.5998 21.1119 34.0392 21.4272 33.4642C21.502 33.332 21.571 33.2055 21.6443 33.0732V33.066L20.536 29.7598C20.5189 29.7919 20.505 29.8256 20.4943 29.8604Z",
    fill: "url(#paint13_linear_5429_43267)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3048 19.5936C30.2444 19.6798 30.1927 19.7603 30.1323 19.8466C29.9583 20.1082 29.7772 20.3684 29.6018 20.6372C29.4265 20.906 29.2123 21.2252 29.0082 21.5299C28.9061 21.6823 28.804 21.8347 28.7005 21.9942C28.3915 22.4672 28.081 22.9559 27.7604 23.4576C27.3665 24.0772 26.9698 24.7197 26.5601 25.3925C26.172 26.0293 25.7709 26.6948 25.3684 27.3777C24.986 28.0303 24.5936 28.6987 24.1954 29.3902C23.8418 30.0083 23.4853 30.648 23.1173 31.3035C23.0972 31.3322 23.0842 31.3696 23.0641 31.3998C22.7062 32.0481 22.3367 32.7194 21.9644 33.4123C21.9535 33.4252 21.9456 33.4404 21.9414 33.4568L23.2179 33.5014C23.1963 33.4899 23.1719 33.487 23.1417 33.4741C25.0371 33.3708 26.8516 32.672 28.3268 31.4774C29.059 30.8801 29.7189 30.1994 30.2933 29.4491C30.794 28.7999 31.253 28.1195 31.6675 27.4122C32.0585 26.7523 32.4524 26.0293 32.8391 25.2415C32.4388 25.3743 32.0225 25.4527 31.6014 25.4744L31.3599 25.4873C31.2794 25.4873 31.2003 25.4873 31.1127 25.4873C32.5006 25.1446 33.7001 24.2741 34.4563 23.0608C33.8932 23.333 33.2853 23.5005 32.6623 23.5553C32.5645 23.5654 32.461 23.5654 32.3575 23.5668C32.3345 23.5668 32.3101 23.5668 32.2785 23.5668C32.7514 23.4528 33.2079 23.2789 33.6369 23.0493C33.7211 23.0062 33.8027 22.9582 33.8813 22.9056C34.0049 22.828 34.1199 22.7417 34.2363 22.6555C34.3097 22.5951 34.3801 22.5405 34.4534 22.4801C34.6228 22.333 34.7796 22.1719 34.922 21.9985C34.9709 21.9425 35.0169 21.8936 35.0572 21.8347C35.1175 21.7484 35.1765 21.6693 35.2282 21.5888C35.4798 21.228 35.6882 20.8988 35.8593 20.6056C35.9441 20.4618 36.0203 20.3267 36.0864 20.2002C36.1094 20.1485 36.1396 20.1039 36.164 20.0565C36.233 19.9127 36.2992 19.7891 36.3466 19.677C36.405 19.5466 36.4563 19.4132 36.5004 19.2773C36.444 19.3124 36.3837 19.3409 36.3207 19.3622C35.7354 19.5671 35.1222 19.6815 34.5023 19.7014C34.4985 19.6996 34.4943 19.6987 34.4901 19.6987C34.4858 19.6987 34.4817 19.6996 34.4778 19.7014C34.4166 19.6982 34.3551 19.6982 34.2938 19.7014C34.3025 19.7014 34.3183 19.7014 34.3269 19.6899L30.3163 19.5462C30.3235 19.572 30.3134 19.5864 30.3048 19.5936Z",
    fill: "url(#paint14_linear_5429_43267)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9192 12.2754C35.4879 12.7627 35.0164 13.3219 34.5018 13.9486C34.4728 13.98 34.4463 14.0136 34.4227 14.0493C33.9757 14.597 33.5056 15.1993 33.0011 15.8648C32.5698 16.4398 32.1098 17.0493 31.6297 17.7192C31.2099 18.2942 30.7859 18.9109 30.3359 19.5606L34.3466 19.7044C35.2677 19.4881 36.1055 19.0074 36.7572 18.3215C36.9168 18.1533 37.0792 17.9708 37.2431 17.7796C37.7562 17.1904 38.2394 16.5758 38.6907 15.9381C39.1054 15.3593 39.4892 14.7591 39.8407 14.1398C40.0254 13.8174 40.1938 13.4859 40.3452 13.1465C40.4559 12.8835 40.5479 12.6348 40.6328 12.3918C39.0606 12.4322 37.4874 12.3933 35.9192 12.2754Z",
    fill: "url(#paint15_linear_5429_43267)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3742 25.5034C31.2937 25.5034 31.2146 25.5034 31.127 25.5034C31.2093 25.4989 31.2918 25.4989 31.3742 25.5034Z",
    fill: "#BE202E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M31.3742 25.5034C31.2937 25.5034 31.2146 25.5034 31.127 25.5034C31.2093 25.4989 31.2918 25.4989 31.3742 25.5034Z",
    fill: "#BE202E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3742 25.5034C31.2937 25.5034 31.2146 25.5034 31.127 25.5034C31.2093 25.4989 31.2918 25.4989 31.3742 25.5034Z",
    fill: "url(#paint16_linear_5429_43267)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 6.84118,
    stroke: "#CC2336"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5429_43267",
    x1: 10.8052,
    y1: 6.29266,
    x2: 15.8129,
    y2: -0.0602547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#F79A23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838,
    stopColor: "#E97826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5429_43267",
    x1: 17.691,
    y1: 44.5958,
    x2: 10.3956,
    y2: 7.80188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C92037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#CD2335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5429_43267",
    x1: 20.5078,
    y1: 39.4199,
    x2: 16.1606,
    y2: 17.4944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#662E8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#9F2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#CD2032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5429_43267",
    x1: 16.9416,
    y1: 42.5956,
    x2: 9.64629,
    y2: 5.80176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C92037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#CD2335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5429_43267",
    x1: 16.9132,
    y1: 39.8125,
    x2: 13.0793,
    y2: 20.4763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#662E8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#9F2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#CD2032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5429_43267",
    x1: 20.7481,
    y1: 41.8402,
    x2: 13.4528,
    y2: 5.04628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C92037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#CD2335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5429_43267",
    x1: 21.0179,
    y1: 44.1598,
    x2: 13.7226,
    y2: 7.36596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C92037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#CD2335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5429_43267",
    x1: 21.8897,
    y1: 41.6154,
    x2: 14.5943,
    y2: 4.82163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C92037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#CD2335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5429_43267",
    x1: 21.7549,
    y1: 41.6414,
    x2: 14.4596,
    y2: 4.84746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C92037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#CD2335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5429_43267",
    x1: 32.9533,
    y1: 8.72698,
    x2: 42.0656,
    y2: 7.59452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#F79A23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838,
    stopColor: "#E97826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5429_43267",
    x1: 7.94818,
    y1: 45.143,
    x2: 31.4201,
    y2: 9.61783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C92037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#CD2335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5429_43267",
    x1: 14.3518,
    y1: 43.215,
    x2: 28.3388,
    y2: 22.0454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#662E8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#9F2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#CD2032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5429_43267",
    x1: 8.93775,
    y1: 42.9307,
    x2: 32.4097,
    y2: 7.4056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C92037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#CD2335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5429_43267",
    x1: 11.1361,
    y1: 40.6613,
    x2: 23.4713,
    y2: 21.9919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#662E8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#9F2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#CD2032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5429_43267",
    x1: 12.6148,
    y1: 45.3595,
    x2: 36.0868,
    y2: 9.8344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C92037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#CD2335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5429_43267",
    x1: 10.98,
    y1: 47.4471,
    x2: 34.452,
    y2: 11.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C92037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#CD2335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97826"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_5429_43267",
    x1: 13.7159,
    y1: 46.0874,
    x2: 37.1878,
    y2: 10.5621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C92037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#CD2335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97826"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMavenJava);
export default __webpack_public_path__ + "static/media/Maven(Java).116bc95508c1356c5eff6359ec1d6a0c.svg";
export { ForwardRef as ReactComponent };